module.exports = __webpack_public_path__ + "static/abilia-casebg-2x-min-a416be22055941202cd288de0c919df7.jpg";